 
export function fixThumbnailUrls(collection: { thumbnailUrls: string[] }, portalDomain: string) {
    return {
        ...collection,
        thumbnailUrls: collection.thumbnailUrls.map((url) => {
            // sometimes we get paths like "/files/long-file-name.jpg" instead of full URLs
            if (url.match(/^\/\w/)) {
                return `https://${portalDomain}${url}`;
            }

            return url;
        }),
    };
}
